import * as classNames from 'classnames';
import * as React from 'react';
import { IValidatorPackage } from '../../Validators';

import './DropdownSearch.css';

interface IDropdownSearchProps {
    required?: boolean;
    deferErrors: boolean;
    label: string;
    options: string[];
    selectedValue: string;
    handleOnChange: (value: string) => void;
    handleOnFocus?: React.FocusEventHandler<HTMLInputElement>;
    handleOnBlur?: React.FocusEventHandler<HTMLInputElement>;
    validators: IValidatorPackage[];
    className?: string;
    placeholder?: string;
}

interface IDropdownSearchState {
    filteredOptions: string[];
    selectedIndex: number;
    typedOption: string;
    touched: boolean;
    open: boolean;
}

class DropdownSearch extends React.PureComponent<IDropdownSearchProps, IDropdownSearchState> {
    optionRefs: {
        [key: number]: HTMLElement | null;
    };
    optionsRef: HTMLElement | null;
    containerRef: HTMLElement | null;
    searchRef: HTMLElement | null;
    constructor(props: IDropdownSearchProps) {
        super(props);

        this.state = {
            filteredOptions: DropdownSearch.getFilteredOptions('', this.props.options),
            selectedIndex: 0,
            typedOption: '',
            touched: false,
            open: false
        };

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.listenForTab = this.listenForTab.bind(this);
        this.optionRefs = {};
    }

    componentDidMount() {
        window.addEventListener('keyup', this.listenForTab);
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this.listenForTab);
    }

    

    UNSAFE_componentWillReceiveProps(nextProps: IDropdownSearchProps) {
        if (nextProps.options !== this.props.options) {
            this.setState({
                filteredOptions: DropdownSearch.getFilteredOptions('', nextProps.options)
            });
        }
    }

    // Needs to switch to  this eventually but needs further research for implementation details
    // static getDerivedStateFromProps(nextProps: IDropdownSearchProps, prevState) {
    //     console.log(`nextProps: `, nextProps);
    //     console.log(`nextprops: `, nextProps.options);
    //     console.log(`prevState: `, prevState);
    //     if (nextProps.options !== prevState.options) {
    //         return {
    //             filteredOptions: DropdownSearch.getFilteredOptions('', nextProps.options)
    //         };
    //     }
    //     console.log(`No change`);
    //     return null;
    // }

    selectOption = (option: string) => {
        if (option) {
            this.props.handleOnChange(option);
            this.setState({
                typedOption: '',
                open: false,
                filteredOptions: DropdownSearch.getFilteredOptions('', this.props.options)
            });
        }
    }

    open() {
        document.addEventListener('click', this.handleClickOutside);
        this.setState({
            open: true
        });
    }

    close() {
        this.setState({
            open: false
        });
    }

    onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.handleOnChange(e.currentTarget.value);
    }

    onBlurInput = (e: React.FocusEvent<HTMLInputElement>) => {
        this.setState({
            touched: true
        });
        this.props.handleOnBlur && this.props.handleOnBlur(e);
    }

    onFocusInput = (e: React.FocusEvent<HTMLInputElement>) => {
        this.props.handleOnFocus && this.props.handleOnFocus(e);
    }

    onChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            typedOption: e.currentTarget.value,
            filteredOptions: DropdownSearch.getFilteredOptions(e.currentTarget.value, this.props.options),
            selectedIndex: 0
        });
    }

    onKeyDownSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // enter
        if (e.keyCode === 13) {
            this.selectOption(this.state.filteredOptions[this.state.selectedIndex]);
        }
        // down arrow
        else if (e.keyCode === 40) {
            const optionIndex = Math.min(this.state.selectedIndex + 1, this.state.filteredOptions.length - 1);
            this.setState({
                selectedIndex: optionIndex
            });
            this.scrollToSelection(optionIndex);
        }
        // up arrow
        else if (e.keyCode === 38) {
            const optionIndex = Math.max(this.state.selectedIndex - 1, 0);
            this.setState({
                selectedIndex: optionIndex
            });
            this.scrollToSelection(optionIndex);
        }
    }

    onClickHeader = (e: React.MouseEvent<HTMLDivElement>) => {
        if (this.state.open === false && this.searchRef) {
            this.searchRef.focus();
        }
        if (this.state.open) {
            this.close();
        }
        else {
            this.open();
        }
    }

    onClickOption = (option: string) => {
        this.selectOption(option);
    }

    onHoverOption = (optionIndex: number) => {
        this.setState({
            selectedIndex: optionIndex
        });
        this.scrollToSelection(optionIndex);
    }

    static getFilteredOptions(filterString: string, options: string[]) {
        const optionsToFilter = options;
        const filterLower = filterString.toLocaleLowerCase();
        const filteredOptions = optionsToFilter.filter((option) => {
            return option.toLocaleLowerCase().substring(0, filterLower.length) === filterLower;
        });
        return filteredOptions.sort((option1, option2) => {
            if (option1 === 'Canada') {
                return -1;
            }
            else if (option2 === 'Canada') {
                return 1;
            }
            else if (option1 === 'United States of America') {
                return -1;
            }
            else if (option2 === 'United States of America') {
                return 1;
            }
            else if (option1 === 'Costa Rica') {
                return -1;
            }
            else if (option2 === 'Costa Rica') {
                return 1;
            }
            else if (option1 < option2) {
                return -1;
            }
            else if (option1 > option2) {
                return 1;
            }
            return 0;
        });
    }

    scrollToSelection = (index: number) => {
        const optionRef = this.optionRefs[index];
        const optionsRef = this.optionsRef;
        if (optionRef && optionsRef) {
            const optionFromTop = optionRef.offsetTop;
            const optionsScrollTop = optionsRef.scrollTop;
            const optionHeight = optionRef.getBoundingClientRect().height;
            const optionsHeight = optionsRef.getBoundingClientRect().height;

            const optionScreenOffset = optionFromTop - optionsScrollTop;
            if (optionScreenOffset < 0) {
                optionsRef.scrollTop = optionFromTop;
            }
            else if (optionScreenOffset + optionHeight > optionsHeight) {
                const difference = optionScreenOffset + optionHeight - optionsHeight;
                optionsRef.scrollTop = optionsScrollTop + difference;
            }
        }
    }

    handleClickOutside = (e: MouseEvent) => {
        if (this.containerRef && this.containerRef.contains(e.target) === false) {
            this.close();
        }
    }

    listenForTab = (e: KeyboardEvent) => {
        if (e.keyCode === 9 && document.activeElement === this.searchRef && this.state.open === false) {
            this.setState({
                open: true
            });
        }
        else if (e.keyCode === 9 && document.activeElement !== this.searchRef && this.state.open === true) {
            this.setState({
                open: false
            });
        }
    }

    render() {
        let valid = true;
        let errorMsg = '';
        this.props.validators.forEach((validatorPackage) => {
            if (!valid) {
                return;
            }
            if (validatorPackage.validator(this.props.selectedValue) === false) {
                valid = false;
                errorMsg = validatorPackage.errorMessage;
            }
        });
        const showError = !valid && (this.props.deferErrors === false);
        const DropdownSearchClasses = classNames('DropdownSearch', this.props.className || '', {
            'DropdownSearch--error': showError,
            'DropdownSearch--open': this.state.open
        });

        return (
            <div className={DropdownSearchClasses}>
                <div className={'DropdownSearch-label'}>
                    {this.props.label}
                    {this.props.required && (
                        <span className={'DropdownSearch-required'}>{' *'}</span>
                    )}
                </div>
                <div className={'DropdownSearch-container'} ref={(x) => { this.containerRef = x; }}>
                    <div className={'DropdownSearch-container-header'} onClick={this.onClickHeader}>
                        <div className={'DropdownSearch-container-header-text'}>
                            {this.props.selectedValue || this.props.placeholder || ''}
                        </div>
                        <div className={'DropdownSearch-container-header-arrow'}>
                            {this.state.open ? '\u25B2' : '\u25BC'}
                        </div>
                    </div>
                    <div className={'DropdownSearch-container-body'}>
                        <div className={'DropdownSearch-container-body-search'}>
                            <input
                                className={'DropdownSearch-container-body-search-input'}
                                type="text"
                                aria-label="Select your location"
                                value={this.state.typedOption}
                                onFocus={this.onFocusInput}
                                onBlur={this.onBlurInput}
                                onChange={this.onChangeSearch}
                                onKeyDown={this.onKeyDownSearch}
                                placeholder={'Please enter or select the full name...'}
                                ref={(x) => { this.searchRef = x; }}
                            />
                        </div>
                        <div className={'DropdownSearch-container-body-options'} ref={(x) => { this.optionsRef = x; }}>
                            {this.state.filteredOptions.map((option, index) => {
                                const optionClasses = classNames('DropdownSearch-container-body-option', {
                                    'DropdownSearch-container-body-option--selected': index === this.state.selectedIndex
                                });
                                return (
                                    <div 
                                        className={optionClasses}
                                        key={index}
                                        onClick={this.onClickOption.bind(this, option)}
                                        onMouseEnter={this.onHoverOption.bind(this, index)}
                                        ref={(x) => { this.optionRefs[index] = x; }}
                                    >
                                        {option}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                {showError && (
                    <div className={'DropdownSearch-error'}>{errorMsg}</div>
                )}
            </div>
        );
    }
}

export default DropdownSearch;
